define('AddCoreFee.View', [
	'add_core_fee.tpl',
	'Backbone',
	'underscore',
], function (add_core_fee_tpl, Backbone, _) {
	'use strict';
	return Backbone.View.extend({
		template: add_core_fee_tpl,

		initialize: function (options) {
			this.application = options.application;

			this.core_fee_formatted = options.core_fee_formatted;
			this.core_fee = options.core_fee;
		},

		getContext: function getContext() {
			return {
				coreFeeFormatted: this.core_fee_formatted,
				coreFee: this.core_fee,
			};
		},
	});
});
